import React from "react";

const colors = {
  autorizada: "success",
  enviada: "dark",
  cancelada: "danger",
  creada: "warning",
  revisada: "primary",
  conciliada: "primary",
  "autorizada-control": "primary",
  liberada: "success",
};

const StatusBadge = ({ fluid, color, text, small }) => {
  return (
    <div
      className={`badge badge-pill py-2 bg-${
        color ? color : colors[text] ? colors[text] : "primary"
      } text-uppercase ${fluid ? "w-100" : ""} ${small ? "small": ""}`}
    >
      {text}
    </div>
  );
};

export default StatusBadge;
